import ProfileService from "../../services/profileService";
import ReportService from "../../services/reportService";

export const plumPaymentHistoryReq = async (
  role = 100,
  params = {},
  getTotal = false
) => {
  const reportData = {
    offset: 0,
    limit: 2,
    isSuperAdmin: role === 1,
    ...params,
  };
  let resData = {};
  await ReportService.multiAdminPaymentsReport(reportData)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.getMultiAdminPaymentReport &&
        response.data.getMultiAdminPaymentReport.success &&
        response.data.getMultiAdminPaymentReport.res
      ) {
        resData = response.data.getMultiAdminPaymentReport || {};
      }
    })
    .catch((error) => {
      console.log(error);
    });
  if (getTotal) {
    return resData.total;
  } else {
    return resData?.res[0];
  }
};

export const empulsPaymentHistory = async (
  role = 100,
  params = {},
  getTotal = false
) => {
  const reportData = {
    offset: 0,
    limit: 2,
    client_dashboard_recharge: 0,
    company_recharge: 1, //empuls fund
    superadmin_recharge: 0, // xoxo point
    ...params,
  };

  let resData = {};

  await ReportService.empulsPaymentsReport(reportData)
    .then((response) => {
      if (
        response !== undefined &&
        response.data.plumProRechargeHistory.error == false &&
        response.data.plumProRechargeHistory.data.count !== 0
      ) {
        resData = response.data.plumProRechargeHistory.data || {};
      }
    })
    .catch((error) => console.log(error));
  if (getTotal) {
    return resData?.count || 0;
  } else {
    return resData?.list[0];
  }
};

export const plumProPaymentHistory = async () => {
  const reportData = {
    offset: 0,
    limit: 2,
    client_dashboard_recharge: 1,
    company_recharge: 0, //empuls fund
    superadmin_recharge: 0, // xoxo point
  };

  let resData = {};

  await ReportService.empulsPaymentsReport(reportData)
    .then((response) => {
      if (
        response !== undefined &&
        response.data.plumProRechargeHistory.error == false &&
        response.data.plumProRechargeHistory.data.count !== 0
      ) {
        resData = response.data.plumProRechargeHistory.data.list[0] || {};
      }
    })
    .catch((error) => console.log(error));

  return resData;
};

export const voucherRechargeHistory = async () => {
  const reportData = {
    offset: 0,
    limit: 2,
    filters: {
      type: ["Deposit"],
      status: ["Complete"],
    },
  };

  let resData = {};
  await ProfileService.plumPaymentsReport(reportData)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.getPlumPaymentReport &&
        response.data.getPlumPaymentReport.success &&
        response.data.getPlumPaymentReport.res
      ) {
        resData = response.data.getPlumPaymentReport.res[0] || {};
      }
    })
    .catch((error) => {
      console.log(error);
    });
  return resData;
};
